import {U} from './global';
import {CARD} from './card';

export const DRAWER = {
    init: function(window, params, callback, preload_window = false, url = '/aj') {
        $(".drawer").removeClass('show');
        $('.menubg').removeClass('show');
        CARD.close();

        $("body .workdrawer").remove();
        if ($("body .workdrawer").length < 1)
            $("body").append('<div class="workdrawer load-animation">' +
                '<div class="close drawer__close"></div>' +
                '<div class="content">' +
                    '<div class="title"></div>' +
                    '<div class="contain"></div>' +
                '</div>' +
            '</div>');

        if (typeof window == 'string')
            $(".workdrawer").addClass(window);

        if (typeof params !== 'object')
            params = {locale: G.locale_id};
        else
            params.locale = G.locale_id;

        if (preload_window==true) {
            $("body, html").addClass('disablescroll');
            $(".menubg").addClass('show');
            $(".main-container").addClass('blur');
            $(".workdrawer").addClass('workdrawer-show');
        }

        $.post(url, params, function (data) {

            $("body, html").addClass('disablescroll');

            $(".menubg").addClass('show');
            $(".main-container").addClass('blur');
            $(".workdrawer").removeClass('load-animation');
            $(".workdrawer .content .title").html(data.title);
            $(".workdrawer .content .contain").html(data.html);

            let bottomHeight = 0;
            let bottomButtons = $(".workdrawer .content .contain .extra-button").length;

            if ((!(typeof data.bottom === "undefined") && data.bottom.length) || (bottomButtons && U.isMobile())) {
                $(".workdrawer").addClass('with-bottom');
                $(".workdrawer .bottom").remove();
                $(".workdrawer").append('<div class="bottom"></div>');

                if (!(typeof data.bottom === "undefined") && data.bottom.length)
                    $(".workdrawer").find('.bottom').append(data.bottom);

                if (bottomButtons && U.isMobile()) {
                    $(".workdrawer").find('.bottom').append('<div class="mobileVisible extra-buttons"></div>');

                    $.each($(".workdrawer .content .contain .extra-button"), function(i, button) {
                        button = $(button).clone();
                        button.removeClass('hiddenMobile');
                        $(".workdrawer .extra-buttons").append(button.outerHTML());
                    });
                }

                bottomHeight = $(".workdrawer .bottom").outerHeight();
            } else
                $(".workdrawer").removeClass('with-bottom');

            $(".workdrawer > .content").css('height', 'calc(100% - ' + bottomHeight + 'px)');
            $(".workdrawer").addClass('workdrawer-show');

            if (typeof callback === "function")
                callback();
        }, 'json');

    },
    destroy: function() {
        if ($('.workdrawer').hasClass('workdrawer-deliverymap')) {
            if (G.city_id!=$('.workdrawer [name=city_id]').val()) {
                document.location.reload();
                return;
            }
        }

        $("body, html").removeClass('disablescroll');
        $('.workdrawer').removeClass('workdrawer-show').delay(200).remove();
        $('.drawer').not('.drawer-menu').removeClass('drawer-show').delay(200).remove();
        $('.menubg').removeClass('show');
        $(".main-container").removeClass('blur');
    },
    onpage_success: function(html, close_timeout = true) {
        $(".workdrawer .content").html(html);

        if (close_timeout) {
            setTimeout(() => {
                this.destroy();
            }, 5000);
        }
    }
}